import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "turbine" }
const _hoisted_2 = { class: "turbine-info" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, "Nr. seryjny", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", null, "Park wiatrowy", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", null, "Model", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, "Platforma", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", null, "Moc", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "Wysokość", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, "Rodzaj wieży", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, "Średnica rotora", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, "Typ łopaty", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = {
  ref: "mapContainer",
  style: {"width":"300px","height":"200px"}
}
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CRow = _resolveComponent("CRow")!
  const _component_CImage = _resolveComponent("CImage")!
  const _component_CCol = _resolveComponent("CCol")!
  const _component_CContainer = _resolveComponent("CContainer")!
  const _component_CSpinner = _resolveComponent("CSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(" Info dla "),
    _createElementVNode("span", null, "WEA" + _toDisplayString(_ctx.$route.params.id), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" Szczegóły techniczne "),
        (_ctx.noErrors)
          ? (_openBlock(), _createBlock(_component_CContainer, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_CRow, {
                  xs: { cols: 1 },
                  md: { cols: 2}
                }, {
                  default: _withCtx(() => [
                    (_ctx.isLoaded)
                      ? (_openBlock(), _createBlock(_component_CCol, {
                          key: 0,
                          sm: "auto",
                          class: "turbine-info"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CRow, null, {
                              default: _withCtx(() => [
                                _createElementVNode("table", null, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_3,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.turbine.serialNo), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_4,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.turbine.windFarm.farmName) + "," + _toDisplayString(_ctx.turbine.windFarm.country), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_CRow, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_CImage, {
                                  fluid: "",
                                  src: "https://images.pexels.com/photos/414837/pexels-photo-414837.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_CCol, {
                      sm: "auto",
                      class: "turbine-info-technical"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isLoaded)
                          ? (_openBlock(), _createBlock(_component_CRow, { key: 0 }, {
                              default: _withCtx(() => [
                                _createElementVNode("table", null, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_5,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.turbine.technicalDetails.modelName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_6,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.turbine.technicalDetails.platform), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_7,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.turbine.technicalDetails.maxPower), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_8,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.turbine.technicalDetails.hubHeight), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_9,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.turbine.technicalDetails.towerType), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_10,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.turbine.technicalDetails.rotorDiameter), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_11,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.turbine.technicalDetails.rotorBladeType), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_CRow, { class: "turbine-location" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Mapa: "),
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, null, 512)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.msg), 1))
      ])
    ]),
    _withDirectives(_createVNode(_component_CSpinner, {
      color: "success",
      class: "spinner"
    }, null, 512), [
      [_vShow, !_ctx.isLoaded]
    ])
  ], 64))
}